/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAxesToDisplay,
  selectRetrofitConfiguration,
  setAxesToDisplay,
  setItemToHighlight,
  selectNewAxisMode
} from "../../../Retrofit/store/slices/retrofit";
import t from "../../../Common/utils/translation/translator";
import LabelSingleton from "../../../Common/components/Inputs/LabelsPicker/LabelSingleton/LabelSingleton";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";

const AxisRecapHeader = ({ ...props }) => {
  const dispatch = useDispatch();
  const axestoDislpay = useSelector(selectAxesToDisplay);

  const configuration = useSelector(selectRetrofitConfiguration);

  const isMobile = useCheckMobileScreen();

  const newAxisMode = useSelector(selectNewAxisMode);

  // if the number of axes changes, reset the axes to display to "all" if it was "with_bundle" or "without_bundle" and there is no axis with bundle or without bundle
  useEffect(() => {
    if (
      (axestoDislpay === "with_bundle" &&
        !configuration?.configData.axes.find(
          (axis) => axis.bundle.motorReference !== null && axis.bundle.motorReference !== undefined
        )) ||
      (axestoDislpay === "without_bundle" &&
        !configuration?.configData.axes.find(
          (axis) => axis.bundle.motorReference === null || axis.bundle.motorReference === undefined
        ))
    ) {
      dispatch(setAxesToDisplay("all"));
    }
  }, [configuration?.configData.axes.length]);

  useEffect(() => {
    // if the number of axes changes, reset the axes to display to "all" if it was "with_bundle" or "without_bundle" and there is no axis with bundle or without bundle
    if (
      (axestoDislpay === "with_bundle" &&
        !configuration?.configData.axes.find(
          (axis) => axis.bundle.motorReference !== null && axis.bundle.motorReference !== undefined
        )) ||
      (axestoDislpay === "without_bundle" &&
        !configuration?.configData.axes.find(
          (axis) => axis.bundle.motorReference === null || axis.bundle.motorReference === undefined
        ))
    ) {
      dispatch(setAxesToDisplay("all"));
    }
  }, [configuration?.configData.axes]);

  return (
    <div
      className="AxisRecapHeader md:grid grid-cols-9 lg:grid-cols-8 text-xs mx-5 -mb-2 bg-white items-center"
      {...props}
    >
      <div className="hidden col-span-1 md:flex md:visible space-x-1">
        <span>
          {axestoDislpay === "all"
            ? configuration?.configData.axes.length
            : axestoDislpay === "with_bundle"
              ? configuration?.configData.axes.filter(
                  (axis) => axis.bundle.motorReference !== null && axis.bundle.motorReference !== undefined
                ).length
              : configuration?.configData.axes.filter(
                  (axis) => axis.bundle.motorReference === null || axis.bundle.motorReference === undefined
                ).length}

          <span className="text-gray-500">/</span>
          {configuration?.configData.axes.length}
        </span>
        <span>{t("msizer.ui.axes_displayed")}</span>
      </div>
      <div className="hidden col-span-5 lg:col-span-4 space-x-1 md:grid grid-cols-5 text-xxs ml-2">
        <div />
        {["nominal_torque", "nominal_speed", "load_inertia", "max_length"].map((item) => (
          <div className="flex items-center justify-center">
            <span
              key={item}
              onMouseEnter={() => {
                dispatch(setItemToHighlight(item));
              }}
              onMouseLeave={() => {
                dispatch(setItemToHighlight(null));
              }}
              className="w-full py-1 text-center bg-gray-50 border-[1px] border-solid border-gray-100 rounded-t flex items-center justify-center select-none cursor-pointer hover:bg-gray-200 transition-all duration-75"
            >
              {t(`msizer.ui.${item}`)}
            </span>
          </div>
        ))}
      </div>
      {!isMobile && (
        <div className="col-span-3 flex justify-end items-center space-x-2">
          <span className="hidden lg:block lg:visible">{t("msizer.ui.filter_by")}</span>
          {["all", "with_bundle", "without_bundle"].map((label, index) => (
            <LabelSingleton
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              label={t(`msizer.ui.${label.toLowerCase()}`)}
              selectedInit={axestoDislpay === label}
              onSelect={() => {
                if (axestoDislpay === label) {
                  dispatch(setAxesToDisplay("all"));
                } else {
                  dispatch(setAxesToDisplay(label));
                }
              }}
              disabled={
                // if the label is "with_bundle" and there is no axis with bundle, disable the button
                // if the label is "without_bundle" and there is no axis without bundle, disable the button
                (label === "with_bundle" &&
                  !configuration?.configData.axes.find(
                    (axis) => axis.bundle.motorReference !== null && axis.bundle.motorReference !== undefined
                  )) ||
                (label === "without_bundle" &&
                  !configuration?.configData.axes.find(
                    (axis) => axis.bundle.motorReference === null || axis.bundle.motorReference === undefined
                  ))
              }
              alwaysSelected
              changeWithInit
            />
          ))}
        </div>
      )}
      {isMobile && !newAxisMode && (
        <div className="bg-gray-50 col-span-3 flex justify-end items-center my-1 pb-1 space-x-2">
          <span className="text-sm">{t("msizer.ui.filter_by")}</span>
          <select
            className="select border-[1px] rounded-sm border-gray-200 py-1 text-sm text-gray-500"
            value={axestoDislpay}
            onChange={(event) => dispatch(setAxesToDisplay(event.target.value))}
          >
            {["all", "with_bundle", "without_bundle"].map((label, index) => (
              <option
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                value={label}
                disabled={
                  (label === "with_bundle" &&
                    !configuration?.configData.axes.find(
                      (axis) => axis.bundle.motorReference !== null && axis.bundle.motorReference !== undefined
                    )) ||
                  (label === "without_bundle" &&
                    !configuration?.configData.axes.find(
                      (axis) => axis.bundle.motorReference === null || axis.bundle.motorReference === undefined
                    ))
                }
              >
                {t(`msizer.ui.${label.toLowerCase()}`)}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default AxisRecapHeader;
